import { render, staticRenderFns } from "./refuseMessage.vue?vue&type=template&id=4857922e&scoped=true&lang=html"
import script from "./refuseMessage.vue?vue&type=script&lang=js"
export * from "./refuseMessage.vue?vue&type=script&lang=js"
import style0 from "./refuseMessage.vue?vue&type=style&index=0&id=4857922e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4857922e",
  null
  
)

export default component.exports